/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/* eslint-disable no-unused-vars */
import React, { Component } from 'react';

import { QuickActionsView } from 'capture-quick-actions';
import { error, errorWithAction } from '../../../components/ErrorToast/ErrorToast';

/* eslint-enable no-unused-vars */
import PostIMSFetchService from '../../../services/PostIMSFetchService';

type Props = {
	locale: string;
	match: {
		url: string;
	};
	env: string;
	history: Object;
	routeSchemaMap: Object;
};

class QuickActions extends Component<Props> {
	/**
	 * [getIMSData consolidates the IMS data for the current user that is passed to the view]
	 * @return {Object} object containing IMS data for the current user
	 */
	getIMSData() {
		if (window.adobeIMS) {
			const userId = window.cchome.util.getUserId();
			const imsData = {
				token: window.adobeIMS.getAccessToken(),
				name: window.adobeIMS.getUserProfile() ? window.adobeIMS.getUserProfile()?.first_name : null,
				email: window.adobeIMS.getUserProfile() ? window.adobeIMS.getUserProfile()?.email : null,
				isSignedUser: Boolean(window.adobeIMS.isSignedInUser(false)),
				userId,
			};
			return imsData;
		}
		return {};
	}

	getPathData() {
		const path = this.props.match.url.split('/');
		return {
			mainTab: path[2],
			productId: path[3],
			pageType: path[4],
		};
	}

	render() {
		const { env, locale, history, routeSchemaMap } = this.props;
		const pathObject = this.getPathData();

		return (
			<QuickActionsView
				environment={env}
				imsData={this.getIMSData()}
				locale={locale}
				routeSchema={routeSchemaMap}
				routeParams={pathObject}
				routing={true}
				error={error}
				errorWithAction={errorWithAction}
				preFetchedRestAPIResponses={PostIMSFetchService.getResponseForKey}
			/>
		);
	}
}

export default {
	component: QuickActions,
};
